import React, { Component } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { connect } from 'react-redux';

import { handleLogin } from '../../utils/authentication';

import User from '../../models/User';

import roleConfig from '../../configs/roles'; 

interface ForwarderRouteState { };

interface ForwarderRouteProps {
  component: any;
  user: User;
  isAuthenticated: boolean;
  location: any;
  componentProps: any;
};

class ForwarderRoute extends Component<ForwarderRouteProps, ForwarderRouteState> {

  componentDidMount() {
    handleLogin();
  };

  render() {

    const { component: Component, user, isAuthenticated, location, componentProps, ...rest } = this.props;

    if (this.props.isAuthenticated !== null) {

      return (
        <Route
          { ...rest }
          render={ props =>
            this.props.isAuthenticated && this.props.user.roleId === roleConfig.roleId.forwarderUser
            ? <Component { ...props } {...componentProps} />
            : <Redirect to={ { pathname: '/', state: { from: props.location } } } />
          }
        />
      );
      
    }

    return null;
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    isAuthenticated: state.auth.success,
    user: state.user,
    location: ownProps.path
  };
};

export default connect(mapStateToProps, null)(ForwarderRoute);